import { CTAFooter } from "./components/CTAFooter";
import { FAQ } from "./components/FAQ";
import { FeatureGrid } from "./components/FeatureGrid";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { HowItWorks } from "./components/HowItWorks";
import { Integrations } from "./components/Integrations";
import { Pricing } from "./components/Pricing";
import { UseCases } from "./components/UseCases";

export default function App() {
  return (
    <div className="min-h-screen bg-white text-slate-950">
      <Header />
      <main>
        <Hero />
        <FeatureGrid />
        <UseCases />
        <HowItWorks />
        <Pricing />
        <Integrations />
        <FAQ />
      </main>
      <CTAFooter />
    </div>
  );
}
